import { constants } from "../../../constants";

export default class Logout {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    PNG_handler() {
        this.gb.emitters.emit.web.closeGame();
    }

    _default() {
        this.gb.emitters.emit.web.logout();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.PNG:
                event["logout"] = this.PNG_handler;
                break;

            default:
                event["logout"] = this._default;
        }

        return event;
    }
}
